<template>
  <div class="page-content">
<!--    <el-button @click="addInfo" type="primary">新增</el-button>-->
<!--    <el-button @click="deleteInfo" type="primary">删除</el-button>-->
    <page-template
      ref="mallroleTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
    <el-dialog title='成员信息' :visible.sync="addShow" @close="closeDialog" width="800px" center :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-col :span="24">
          <el-form-item label='名称' prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='微信号' prop="wechantCode">
            <el-input v-model="form.wechantCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='角色' prop="type">
            <el-radio-group v-model="form.type">
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <div class="dialog-footer">
          <el-button type="primary" @click="save">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import qs from 'qs'
export default {
  components: {
    pageTemplate
  },
  data() {
    let validateWeixin = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('微信号不能为空'));
      }else{
        var reg= /^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/;
        if(!reg.test(value)){
          callback(new Error('请输入正确的微信号码'));
        }else{
          callback();
        }
      }
    };
    return {
      dialogTitle:'',
      addShow:false,
      form:{
        name:'',
        wechantCode:'',
        type:2,//1管理员 2主播 3运营者'
        relateType:this.$utils.getSysUser().storeId?20:10,//10 商户 20门店
      },
      rules:{
        name:[{required:true,message:'请输入名称',trigger:'change'}],
        type:[{required:true,message:'请选择角色',trigger:'change'}],
        wechantCode:[{required:true,pattern: this.$utils.reg.wechat, message: '请输入正确的微信号', trigger: 'change'}],
      },
      typeList:this.$utils.getCacheStatus('mallLiveRole.type'),
      // 搜索条件
      searchOptions: {
        simple: [
          {label: '名称', prop: 'name', type: 'input', isFuzzy: true, placeholder: "请输入名称"}
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update',
          callback: this.editInfo,
          filter:()=>{
            return false
          }
        },
        {
          label: '新增',
          type: this.$utils.buttonType.tableOperate,
          code: 'insert',
          callback: this.addInfo,
        },
        {
          label: '删除',
          type: this.$utils.buttonType.tableOperate,
          code: 'delete',
          callback:this.deleteInfo
          // filter:()=>{
          //   return false
          // }
        },
      ],
      // 表格信息配置
      tableOptions: {
        // showSelect: true,
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '名称',
            prop: 'name',
            align: 'center',
            width: '100',
          },
          {
            label: '微信号',
            prop: 'wechantCode',
            align: 'center',
            width: '100',
          },
          {
            label: '角色',
            prop: 'type',
            align: 'center',
            width: '100',
            enumData: this.$utils.getCacheStatus('mallLiveRole.type')
          },
          {
            label: '创建时间',
            prop: 'createDttm',
            align: 'center',
            width: '120',
          },
        ],
        url: api.mall.mallLiveRole
      },

    };
  },
  created() {

  },
  mounted() {
  },
  methods: {
    // 创建
    addInfo(){
      this.addShow = true
      this.dialogTitle = 'add'
    },
    // 编辑
    editInfo(){
      this.addShow = true
      this.dialogTitle = 'edit'
    },
    // 保存
    save(){
      this.$refs.form.validate(valid=>{
        if(valid){
          this.$axios.fetchPost(api.mall.mallLiveRole,this.form).then(res=>{
            if(res.code === 200){
              if(res.data.codeUrl){//未认证
                this.$confirm('请先去认证身份, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  window.open(res.data.codeUrl, "_blank");
                  this.closeDialog()
                }).catch(() => {
                  this.$notify({
                    type: "info",
                    title: '认证操作',
                    message: '取消',
                    showClose: false,
                  });
                  // this.$message({
                  //   type: 'info',
                  //   message: '已取消认证'
                  // });
                });
              }else{
                this.$notify({
                  type: "success",
                  title: '新增操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message.success('新增成功')
                this.$refs.mallroleTemplate.operationSuccess()
                this.closeDialog()
              }
            }else{
              this.$notify({
                type: "error",
                title: '新增操作',
                message: '失败',
                showClose: false,
              });
              // this.$message.error( res.errorMsg||'保存失败')
            }
          }).finally(()=>{

          })
        }else{
          return false
        }
      })
    },
    // 删除
    deleteInfo(row){
      this.$confirm('删除本条数据, 是否确认?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.fetchDelete(api.mall.mallLiveRole+'?id='+row.id).then(res=>{
          if(res.code === 200){
            this.$notify({
              type: "success",
              title: '删除操作',
              message: '成功',
              showClose: false,
            });
            // this.$message.success('删除成功')
            this.$refs.mallroleTemplate.operationSuccess()
          }else{
            this.$notify({
              type: "error",
              title: '删除操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error(res.errorMsg || '删除失败')
          }
        })
      }).catch(() => {});

    },
    // 关闭
    closeDialog(){
      this.addShow = false
      this.form={
        name:'',
        wechantCode:'',
        type:2,//1管理员 2主播 3运营者'
        relateType:this.$utils.getSysUser().storeId?20:10,//10 商户 20门店
      }
      this.$refs.form.resetFields()
    },
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/system/applet/live/members.vue